export default {
  tag: "Guía de Operación",
  title1: "Cómo Operar un Food Truck",
  title2: "en el Condado de Orange",
  subtitle:
    "Una guía paso a paso para obtener un permiso de instalación de comida móvil en el Condado de Orange.",
  steps: [
    {
      title: "Registra Tu Negocio",
      desc: "Presenta un DBA (Doing Business As) ante el secretario del Condado de Orange y obtén tu EIN del IRS. Esta es la base de tu entidad comercial legal.",
    },
    {
      title: "Asegura un Acuerdo de Comisaría",
      desc: "Todas las unidades de comida móvil en el Condado de Orange deben operar desde una cocina comisaría con licencia. Debes tener un acuerdo de comisaría firmado antes de solicitar tu permiso de instalación de comida móvil.",
    },
    {
      title: "Pasa la Inspección de Construcción",
      desc: "Tu food truck debe pasar una inspección preliminar de construcción. Todo el equipo debe cumplir con los estándares NSF y el vehículo debe construirse según las especificaciones del condado.",
    },
    {
      title: "Solicita los Permisos Requeridos",
      desc: "Presenta tu solicitud de permiso de Instalación de Comida Móvil (MFF) ante Salud Ambiental del Condado de Orange. El procesamiento puede tardar de 4 a 8 semanas — te ayudamos a preparar una solicitud completa para evitar demoras.",
    },
    {
      title: "Obtén Licencias Comerciales",
      desc: "Obtén una licencia comercial de cada ciudad del Condado de Orange donde planeas operar. Muchas ciudades también requieren un permiso de vendedor separado o una licencia de vendedor de comida móvil.",
    },
    {
      title: "Programa la Inspección de Evaluación",
      desc: "Para comprender completamente las regulaciones del Condado de Orange y los requisitos de cocina, programa la Evaluación de tu MFF con nuestro experto para determinar tu siguiente paso.",
    },
  ],
  stats: [
    { value: "3,200+", label: "Food Trucks Registrados en el Condado de Orange" },
    { value: "34", label: "Ciudades en Todo el Condado de Orange" },
    { value: "4–8 sem", label: "Tiempo Promedio de Procesamiento de Permisos" },
    { value: "$800–$2,400", label: "Costos Anuales Típicos de Permisos" },
  ],
};